import axios from '@/api/config';

const goodsAgentPrice = {
  getGoodsAgentPriceById(data) {
    return axios.get(`${process.env.BASE_URL}/goodsAgentPrice/getGoodsAgentPrice/` + data, {});
  },
  getGoodsAgentPrice(data) {
    return axios.get(`${process.env.BASE_URL}/goodsAgentPrice/getGoodsAgentPrice`, {params: data});
   },
  getGoodsAgentPriceList(data) {
    return axios.get(`${process.env.BASE_URL}/goodsAgentPrice/getGoodsAgentPriceList`, {params: data});
  },
  getGoodsAgentPriceTree(data) {
    return axios.get(`${process.env.BASE_URL}/goodsAgentPrice/getGoodsAgentPriceTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/goodsAgentPrice/pageList`, data);
  },
  addGoodsAgentPrice(data) {
    return axios.post(`${process.env.BASE_URL}/goodsAgentPrice/addGoodsAgentPrice`, data);
  },
  updateGoodsAgentPrice(data) {
    return axios.put(`${process.env.BASE_URL}/goodsAgentPrice/updateGoodsAgentPrice`, data);
  },
  deleteGoodsAgentPrice(data) {
    return axios.delete(`${process.env.BASE_URL}/goodsAgentPrice/deleteGoodsAgentPrice`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/goodsAgentPrice/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/goodsAgentPrice/importData`, data);
  },
  addGoodsAgentPriceBatch(data) {
    return axios.post(`${process.env.BASE_URL}/goodsAgentPrice/addGoodsAgentPriceBatch`, data);
  },
  getAgentLevelList(data) {
    return axios.get(`${process.env.BASE_URL}/agentLevel/getAgentLevelList`, {params: data});
  },
    copyGoodsInfoCenter(data) {
    return axios.get(`${process.env.BASE_URL}/goodsInfoCenter/copyGoodsInfoCenter`, {params: data});
  },
}

export default goodsAgentPrice;



// WEBPACK FOOTER //
// ./src/api/goodsAgentPrice.js